import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import Help from '../../Common/Help';
import withShallowComparison from '../../Common/withShallowComparisonUpdate';

import './style.scss';
import ConfigService from '../../../Services/api/Config';
import Icon from '../../Common/Icon';
import { ReactComponent as RadioIcon } from '../../../../img/radio-checked.svg';

class Radio extends React.PureComponent {
  handleClickLabel = (event) => {
    const { onChange, disabled } = this.props;
    if (disabled) return;
    if (onChange) onChange();
    if (event) {
      $(event.target).closest('.InputRadio').find('.InputRadio_Input').trigger('focus');
    }
  };

  handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      this.handleClickLabel(event);
    }
  };

  render() {
    const { className, label, disabled, compact, help, checked } = this.props;

    const styleLabel = {};

    if (className && className.includes('InputRadio_Compact') && Boolean(checked)) {
      styleLabel['backgroundColor'] = ConfigService.getColor('primaryColor');
      styleLabel['borderColor'] = ConfigService.getColor('primaryColor');
    }

    // eslint-disable-next-line no-nested-ternary
    let color = null;
    if (disabled) {
      color = (checked ? 'tertiaryColor' : 'white');
    }
    else {
      color = (checked ? 'secondaryColor' : 'white');
    }
    // eslint-disable-next-line no-nested-ternary
    let colorHover = null;
    if (disabled) {
      colorHover = (checked ? 'tertiaryColor' : 'white');
    }
    else {
      colorHover = 'secondaryColor';
    }

    return (
      <div className={classNames('InputRadio Relative', className)} onClick={this.handleClickLabel}>
        <input
          {...this.props}
          type="radio"
          disabled={disabled}
          checked={checked}
          className={classNames('InputRadio_Input', {
            InputRadio_Disabled: Boolean(disabled)
          })}
          onKeyPress={this.handleKeyPress}
        />
        {!compact && (
          <Icon className="Relative" width="16" height="16" color={color} changeColor="secondaryColor" hoverColor={colorHover}>
            <RadioIcon alt="radio-checked" />
          </Icon>
        )}
        <div
          className={classNames('InputRadio_Label', {
            InputRadio_Label_Checked: Boolean(checked),
            InputRadio_Label_Help: Boolean(help)
          })}
          style={styleLabel}>
          {label}
        </div>
        {help && <Help message={help} className="Tooltip_Top" />}
      </div>
    );
  }
}

Radio.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string.isRequired,
  help: PropTypes.string,
  // compact: PropTypes.bool,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  onChange: PropTypes.func
};

export default withShallowComparison(Radio, ['onChange', 'onError']);
